import { BatteryAlertBluetoothIcon } from './BatteryAlertBluetoothIcon';

/**
 * author: GreenTurtwig
 * id 7C1C81FB-9E38-4220-B225-460056043383
 * name battery-alert-bluetooth
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-alert-bluetooth.svg
 * tags
 * - Alert / Error 
 * - Battery 
 */
export const BatteryWarningBluetoothIcon = BatteryAlertBluetoothIcon;
export default BatteryWarningBluetoothIcon